<template>
	<div
		v-if="ordersEnhanced.length"
		class="order-state"
	>
		<vue-glide
			v-model="activeSlide"
			class="order-state__slider"
			v-bind="glideOptionsEnhanced"
		>
			<vue-glide-slide
				class="order-state__slide"
				v-for="order in ordersEnhanced"
				:key="order.tokenValue"
				:class="[
					`order-state__slide--step-${order.step}`
				]"
			>
				<div class="order-state__slide-wrapper">
					<div
						class="order-state__slide-title"
						v-html="$t(`orderstate.states.${order.stateConfig.state}`)"
					/>
					<div class="order-state__slide-animation">
						<div class="order-state__slide-animation-wrapper">
							<svg class="order-state__slide-animation-progress" xmlns="http://www.w3.org/2000/svg" width="132" height="132" fill="none" viewBox="0 0 132 132">
								<path d="M2.43 58.09h.19c1.19 0 2.18-.88 2.36-2.06C9.02 30.12 29.29 9.51 55.03 4.96c1.17-.21 2.04-1.2 2.04-2.39v-.13c0-1.51-1.36-2.66-2.85-2.4C26.35 4.93 4.4 27.24.03 55.29c-.23 1.47.91 2.8 2.4 2.8Z" fill="var(--status-segment-4, currentColor)"/>
								<path d="M2.851 75.48h.18l-.01.01a2.41 2.41 0 0 1 2.36 1.97c4.88 24.82 24.71 44.33 49.7 48.72 1.15.2 1.98 1.23 1.98 2.4v.12c0 1.51-1.37 2.65-2.86 2.39-27.02-4.75-48.48-25.86-53.74-52.7-.29-1.51.86-2.91 2.39-2.91Z" fill="var(--status-segment-3, currentColor)"/>
								<path d="M74.461 128.57v.12a2.431 2.431 0 0 0 2.86 2.39c27.02-4.75 48.48-25.85 53.74-52.69.29-1.5-.85-2.91-2.39-2.91h-.18c-1.16 0-2.13.83-2.36 1.97-4.88 24.82-24.71 44.32-49.7 48.71-1.15.2-1.98 1.23-1.98 2.4l.01.01Z" fill="var(--status-segment-2, currentColor)"/>
								<path d="M74.459 2.44v.14c0 1.19.87 2.19 2.04 2.39 25.741 4.55 46.011 25.15 50.051 51.07.18 1.18 1.17 2.06 2.36 2.06h.18c1.49 0 2.63-1.33 2.4-2.8C127.13 27.24 105.18 4.94 77.31.04a2.44 2.44 0 0 0-2.851 2.4Z" fill="var(--status-segment-1, currentColor)"/>
							</svg>
							<div class="order-state__slide-animation-player">
								<lottie-vue-player
									:key="`${order.number}-${order.state}`"
									:src="themeFilesPath(`lottie/${order.stateConfig.lottieFile || lottieFile}`)"
									autoplay
									loop
								/>
							</div>
						</div>
						<div
							class="order-state__slide-animation-steps"
							v-html="$t('orderstate.step', { step: order.step, steps: states.length })"
						/>
					</div>
					<div class="order-state__slide-details">
						<div class="order-state__slide-row">
							<div
								class="order-state__slide-channel"
								v-html="order.channel.name"
							/>
						</div>
						<div class="order-state__slide-row">
							<a
								class="order-state__slide-number"
								:href="order.url"
								target="_blank"
								v-html="order.number"
							/>
							<div
								class="order-state__slide-date"
								v-html="order.date"
							/>

						</div>
						<div class="order-state__slide-row">
							<div
								class="order-state__slide-method"
								v-html="$t(`orderstate.${order.shippingCode}`)"
							/>
							<div
								class="order-state__slide-items"
								v-html="$tc('orderstate.items', order.itemCount, { count: order.itemCount})"
							/>
						</div>
						<div class="order-state__slide-row">
							<div
								class="order-state__slide-price"
								v-html="$options.filters.fwgpricecent(order.total, 'html')"
							/>
						</div>
					</div>
				</div>
			</vue-glide-slide>
		</vue-glide>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Glide, GlideSlide } from 'vue-glide-js'
// import Dumpling from '@/lottiefiles/dumpling';
import dayjs from '@/helpers/dayjs'

export default {
	components: {
		[Glide.name]: Glide,
		[GlideSlide.name]: GlideSlide,
	},
	props: {
		tokenValues: Array,
	},
	data() {
		return {
			lottieFile: 'dumpling.json',
			interval: null,
			activeSlide: 0,
			glideOptions: {
				type: 'carousel',
				startAt: 0,
				perView: 1,
				focusAt: 'center',
				gap: 0,
				autoplay: 0,
				hoverpause: true,
				keyboard: false,
				bound: false,
				swipeThreshold: 80,
				dragThreshold: 120,
				perTouch: 0,
				touchRatio: 0.5,
				touchAngle: 45,
				animationDuration: 100,
				rewind: true,
				peek: 0,
			},
			states: [
				{
					state: 'prepare',
					codes: [
						10,
					],
					lottieFile: 'prepare.json',
				},
				{
					state: 'pickup',
					codes: [
						60,
					],
					lottieFile: 'pickup.json',
				},
				{
					state: 'deliver',
					codes: [
						70,
					],
					lottieFile: 'deliver.json',
				},
				{
					state: 'complete',
					codes: [
						110,
					],
					lottieFile: 'complete.json',
				},
			]
		}
	},
	computed: {
		...mapGetters('order', [
			'notimeOrderStates',
		]),
		glideOptionsEnhanced() {
			const enable = this.ordersEnhanced.length > 1;
			return {
				...this.glideOptions,
				bullet: enable,
				swipeThreshold: enable && this.glideOptions.swipeThreshold,
				dragThreshold: enable && this.glideOptions.dragThreshold,
			}
		},
		ordersEnhanced() {
			return this.notimeOrderStates
				.map(order => {
					const index = this.states.findIndex(s => s.codes.includes(order.state))
					return {
						...order,
						date: dayjs(order.date).format('L'),
						stateConfig: this.states[index],
						step: index + 1,
					}
				})
		}
	},
	watch: {
		ordersEnhanced(newValue, oldValue) {
			if (this.activeSlide >= newValue.length) {
				this.activeSlide = 0;
			}
		}
	},
	methods: {
		async updateStates() {
			await this.$store.dispatch('order/getNotimeOrderState', { tokenValues: this.tokenValues})
		}
	},

	mounted() {
		this.updateStates()

		clearInterval(this.interval)
		this.interval = setInterval(() => {
			this.updateStates()
		}, this.themeValue('THEME_ORDER_STATE_INTERVAL'));
	},
	destroyed() {
		clearInterval(this.interval)
	}
}
</script>
